import { bankServices } from "../../config/axios";
import {
    ADDUPDATE_USERDETAILS_SUCCESS,
    ADDUPDATE_USERDETAILS_FAILED,
    RESET_ADDUPDATE_USERDETAILS,
    LOADING_ADDUPDATE_USERDETAILS,
    ADDUPDATE_USERDETAILS_NETWORKERROR,
} from '../types/index';

const resetaddUpdateUserManagement = () => {
    return { type: RESET_ADDUPDATE_USERDETAILS };
};

const addUpdateUserManagement = (userData, authTokenIs) => async (dispatch) => {
    dispatch({ type: LOADING_ADDUPDATE_USERDETAILS });
    await bankServices
        .post("updateUserDetails", userData, { headers: { AuthToken: authTokenIs } })
        .then((res) => {
            switch (res.data.status) {
                case "success":
                    dispatch(success(res.data));
                    break;
                default:
                    dispatch(failed(res.data));
                    break;
            }
        })
        .catch((err) => {
            dispatch({
                type: ADDUPDATE_USERDETAILS_NETWORKERROR,
                payload: err
            });
        });
}

function success(data) {
    return {
        type: ADDUPDATE_USERDETAILS_SUCCESS,
        payload: data
    };
}
function failed(data) {
    return {
        type: ADDUPDATE_USERDETAILS_FAILED,
        payload: data
    };
}

export { resetaddUpdateUserManagement, addUpdateUserManagement }